import { render, staticRenderFns } from "./robotTelephoneInfo.vue?vue&type=template&id=09525dab&scoped=true"
import script from "./robotTelephoneInfo.vue?vue&type=script&lang=js"
export * from "./robotTelephoneInfo.vue?vue&type=script&lang=js"
import style0 from "./robotTelephoneInfo.vue?vue&type=style&index=0&id=09525dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09525dab",
  null
  
)

export default component.exports